import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function SkeletonCard() {
  return (
    <Card className="border border-gray-100 shadow-sm overflow-hidden">
      <CardContent className="p-0">
        <div className="flex flex-col space-y-0 animate-pulse">
          <Skeleton className="h-[250px] w-full rounded-none" />
          <div className="flex gap-2 flex-col p-5">
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-4 w-5/6 mt-1" />
            <div className="flex gap-2 mt-2">
              <Skeleton className="h-6 w-16 rounded-full" />
              <Skeleton className="h-6 w-16 rounded-full" />
              <Skeleton className="h-6 w-16 rounded-full" />
            </div>
            <div className="flex justify-end mt-4">
              <Skeleton className="h-6 w-28" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
